import { request } from "apis/base";
import {
  LoginData,
  ChangePasswordData,
  RegisterData,
} from "constants/types/auth";

const prefix = "/jwt";

export const authApi = {
  login: (data: LoginData) => {
    return request({
      url: `${prefix}/login`,
      method: "POST",
      data,
    });
  },
  logout: () => {
    return request({
      url: "/auth/v1/sign_out",
      method: "POST",
    });
  },
  checkSession: () => {
    return request({
      url: `${prefix}/check`,
      method: "GET",
    });
  },
  refreshToken: (refreshToken: string) => {
    return request({
      url: `${prefix}/refresh`,
      method: "POST",
      data: {
        refresh_token: refreshToken,
      },
    });
  },
  changePassword: (data: ChangePasswordData) => {
    return request({
      url: "/auth/v1/change_password",
      method: "PUT",
      data: data,
    });
  },
  register: (data: RegisterData) => {
    return request({
      url: "/auth/v1/sign_up",
      method: "POST",
      data: data,
    });
  },
};
